import React from 'react'
import "./styles/Showcase.css"
import Project from './Project'

const Showcase = () => {
  return (
    <div className='section main'>
        <h3 className='green'>My Projects : </h3>
        <div className="showcase">
        <Project title="Crock" description="An OpenGL based game engine written in C++." link="https://www.github.com/IssamRamzi/Crock"/>
        <Project title="CRS" description="An ALPR admin panel wirtten in java." link="https://github.com/IssamRamzi/PlateRecognition/tree/Final"/>
        <Project title="Simulmata" description="An automata simulation program written in C++." link="https://github.com/IssamRamzi/Simulmata"/>
        </div>
        
    </div>
  )
}

export default Showcase